export const FIREBASE_API_KEY = "AIzaSyAZxrhLZyUctbGSghnc8l8XM0dYM84b0mM";